<template>
  <div>
    <div class="login-body">
      <div class="left">
        <img class="bcg" src="@/assets/photos/background.png" alt="">
      </div>
      <div class="right">
        <div class="login-box">
          <div class="login-title">
            <div class="title">5G急救车信息系统</div>
            <div>登录</div>
          </div>
          <div class="input-box">
            <el-form
              ref="ruleForm"
              :model="ruleForm"
              :rules="rules"
              label-width="0px"
            >
              <el-form-item prop="account" class="user-input">
                <el-input
                  v-model="ruleForm.account"
                  class="userImg"
                  type="text"
                  autocomplete="off"
                  placeholder="账号"
                  maxlength="10"
                  show-word-limit
                />
              </el-form-item>
              <el-form-item prop="password" class="password-input">
                <el-input
                  v-model="ruleForm.password"
                  class="passwordImg"
                  type="text"
                  autocomplete="off"
                  placeholder="密码"
                  show-password
                  @keyup="onHCapitalize($event, 'ruleForm')"
                />
                <i v-show="bigChar" class="big-char">大写锁定已打开</i>
              </el-form-item>

              <div class="option-button">
                <el-checkbox
                  v-model="checked"
                  name="type"
                >记住账号
                </el-checkbox>
                <el-button
                  :underline="false"
                  type="text"
                  @click="forgetPassword = true"
                >找回密码
                </el-button>
              </div>
              <div class="login-tip">
                <div v-show="passwordError">
                  帐号或密码不正确，请重新输入！
                </div>

              </div>
              <el-button
                type="primary"
                class="login-button"
                @click="submitForm('ruleForm')"
              >登录
              </el-button>
            </el-form>
          </div>
        </div>
        <div class="login-footer">
          <div>
            <a href="#">关于我们</a>
          </div>
          <div>
            <a href="#">版权所有@广州信瑞医疗技术有限公司</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 找回密码弹窗 -->
    <my-dialog
      :width="400"
      title="提示"
      :dialog-carted="forgetPassword"
      @confirmOk="forgetPassword = false"
    >
      <template #content>
        <div>请联系信息科人员解决帐号问题。</div>
      </template>
    </my-dialog>

    <my-dialog
      :width="400"
      title="提示"
      :dialog-carted="loginError"
      @confirmOk="loginError = false"
    >
      <template #content>
        <div>{{ loginErrorMessage }}</div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import { login } from "@/api/login";
import Cookies from "js-cookie";
import md5 from "js-md5";
import MyDialog from "@components/customDialog/MyDialog.vue";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "Login",
  components: {
    MyDialog
  },
  data() {
    return {
      loginErrorMessage: "", // 登录出现问题的提示
      ruleForm: {
        account: "gly",
        password: "123"
      },
      rules: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur"
          }
        ]
      },
      checked: true,
      bigChar: false, // 大写锁监听
      // 找回密码
      forgetPassword: false, // 找回密码
      passwordError: false, // 密码错误
      loginError: false // 未知错误
    };
  },
  mounted() {
    // 去本地储存检查是否记住密码了
    const data = JSON.parse(localStorage.getItem("loginStatus"));
    // 如果是记住登陆状态的话, 自动登陆跳转
    if (data) {
      this.checked = true;
      this.ruleForm = {
        ...data
      };
      // this.loginAction();
    }
  },
  methods: {
    // 提交表单
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.loginAction();
        } else {
          console.log("密码或帐号不够长");
          return false;
        }
      });
    },
    /**
     * 进行登录操作
     * */
    async loginAction() {
      this.loginError = false;
      const { account, password } = this.ruleForm;
      const form = {
        account,
        password: md5(password, 32) // MD5加密
      };
      try {
        const res = await login(form);
        const { code, token } = res;
        if (code === "1") {
          this.$store.commit("updateUserInfo", res);
          const data = this.checked ? { isChecked: 1, ...this.ruleForm } : null;
          localStorage.setItem("loginStatus", JSON.stringify(data));
          Cookies.set("token", token);
          sessionStorage.setItem("token", token);
          try {
            await this.$router.push("/index");
          } catch (error) {
            console.error(error);
          }
        } else {
          this.passwordError = true;
        }
      } catch (e) {
        this.loginErrorMessage = `登录失败, 原因如下${e}.请重试.`;
        this.loginError = true;
      }
    },
    /**
     * 监听大写键被按下
     * */
    onHCapitalize(event, ruleForm) {
      this.passwordError = false;
      if (event.keyCode === 20) {
        this.bigChar = !this.bigChar;
        return;
      }
      // 順帶監聽 回车登陆事件
      if (event.keyCode === 13) {
        // 如果是回车键的话,那么执行提交函数
        this.submitForm(ruleForm);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.login-body {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
}

.left {
  flex: 1;

  .bcg {
    height: 100%;
    width: 100%;
  }
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 100vh;
  width: 640px;
  overflow: auto;

  .login-box {
    flex: 1;
  }

  .login-title {
    padding: 120px 0;
    font-size: 32px;
    color: #333333;
    text-align: center;
    letter-spacing: 3px;

    div {
      font-weight: bold;
    }

    .title {
      margin-bottom: 60px;
    }
  }

  .login-footer {
    text-align: center;
    height: 62px;

    > div {
      line-height: 26px;
      height: 26px;
    }

    a {
      text-decoration: none;
      font-size: 14px;
      color: #CCCCCC;
    }
  }
}

.input-box ::v-deep {
  .option-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    //margin-bottom: 24px;

    .el-button {
      font-size: 16px;
      color: #999999;
    }

    .el-checkbox__label {
      font-size: 16px;
      color: #999999;
      padding-top: 1px;
    }
  }

  .password-input {
    position: relative;
  }

  // 鍵盤大寫提示框
  .big-char {
    position: absolute;
    border: 1px solid #0b5480;
    color: #0b5480;
    background: #fff6;
    font-size: 12px;
    padding: 5px;
    border-radius: 5px;
    right: -99px;
    bottom: 5px;
    height: 20px;
    line-height: 20px;
  }

  .login-button {
    width: 400px;
    height: 44px;
    border: none;
    background: #75B8E6;
    border-radius: 6px;
    font-size: 16px;
    letter-spacing: 6px;
  }
}

.login-box ::v-deep {
  width: 400px;

  .el-form-item {
    margin-bottom: 25px;
  }

  .el-input__inner {
    width: 400px;
    border: 1px solid #999999;
    border-radius: 6px;
    font-size: 16px;
    color: #CCCCCC;
    height: 44px;
  }

  .userImg .el-input__inner {
    background: url(../assets/photos/user.png) no-repeat 15px 12px;
    padding: 0 50px;
  }

  .passwordImg .el-input__inner {
    background: url(../assets/photos/password.png) no-repeat 15px 12px;
    padding: 0 50px;
  }

  /* 保持登入按钮*/
  .el-checkbox__inner {
    width: 18px;
    height: 18px;
    border: 1px solid #666666;
    border-radius: 4px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #0b5480;
    background-color: #fbfbfb;
  }

  .el-checkbox__inner::after {
    border: 2px solid #0b5480;
    border-left: 0;
    border-top: 0;
    height: 8px;
    left: 6px;
    position: absolute;
    top: 2px;
  }

  /* 小圖標,給密碼用的 */
  .el-checkbox__input.is-checked + .el-checkbox__label {
    font-size: 16px;
    color: #0b5480;
  }
}

.login-tip {
  padding: 16px 0;
  font-size: 14px;
  color: #EB7979;
}
</style>
